// const ADD_ORDER = "add-order"
const DAILY_MENU_TABLE_READY_STATUS = "daily-menu-table-ready-status"

const SEARCH_TEXT_STATE_UPDATE = "daily-menu-table-search-text-state-update"
const ROWS_PER_PAGE_STATE_UPDATE = "daily-menu-table-rows-per-page-state-update"
const PAGINATION_UPDATE = "daily-menu-table-pagination-update"
const LAST_RECORDED_TIME = "daily-menu-table-last-recorded-time"

const DAILY_MENU_ID_FOR_ACTION = "daily-menu-table-daily-menu-id-for-action"
const SELLER_SCHEDULE_MENU_ID_FOR_ACTION = "daily-menu-table-seller-schedule-menu-id-for-action"
const DATE_UPDATE_FOR_STATE_MAINTENANCE ="daily-menu-table-date-update-for-state-maintenance"

const SELLER_SCHEDULE_MENU_STATUS_SELECTED = "daily-menu-table-seller-menu-status-selected"

const PUSH_DAILY_MENU_VALUE = "daily-menu-table-push-daily-menu-value"



//const CURRENT_DAILY_MENU_DETAILS_ID = "daily-menu-table-current-daily-menu-deatils-id"



const initialState = {
    // orderData: [],
    isDailyMenusTableReady:true,
    dailyMenus:{},
    pushDailyMenuDetails:null,
    previousStartDateState: "",
    previousEndDateState: "",
    previousSearchFieldText: "",
    previousSizePerPageValue: 15,
    previousPaginationState: 1,
    previousSellerMenuSelectedStatusFilter: "",
    dailyMenuIdForAction:null,
    sellerScheduleMenuIdForAction:null
    

}

export default function reducer(state = initialState, action) {
    let duplicateState = null

    switch (action.type) {
        case DAILY_MENU_TABLE_READY_STATUS:
            return Object.assign({}, state, { isDailyMenusTableReady: action.payload })
            

        case SELLER_SCHEDULE_MENU_ID_FOR_ACTION:
            return Object.assign({},state,{sellerScheduleMenuIdForAction:action.payload})
        
        case DAILY_MENU_ID_FOR_ACTION:
            return Object.assign({},state,{dailyMenuIdForAction:action.payload})
        
        case LAST_RECORDED_TIME:
            return Object.assign({}, state, { lastRecordedTime: action.payload })
        
        case DATE_UPDATE_FOR_STATE_MAINTENANCE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousStartDateState = action.payload.start_date
            duplicateState.previousEndDateState = action.payload.end_date
            return Object.assign({}, state, duplicateState)

        case SEARCH_TEXT_STATE_UPDATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)

        case ROWS_PER_PAGE_STATE_UPDATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousSizePerPageValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PAGINATION_UPDATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousPaginationState = action.payload
            return Object.assign({}, state, duplicateState)

        case SELLER_SCHEDULE_MENU_STATUS_SELECTED:
            duplicateState = Object.assign({}, state)
            duplicateState.previousSellerMenuSelectedStatusFilter = action.payload
            return Object.assign({}, state, duplicateState)
        
        case PUSH_DAILY_MENU_VALUE:
        return Object.assign({}, state, { pushDailyMenuDetails: action.payload })

        default:
            return state
    }
}



export function dailyMenuTableReady(data) {
    return {
        type: DAILY_MENU_TABLE_READY_STATUS,
        payload: data
    }
}



export function lastRecordedTime(data) {
    return {
        type: LAST_RECORDED_TIME,
        payload: data
    }
}

export function sellerScheduleMenuIdForAction(id){
    return {
        type:SELLER_SCHEDULE_MENU_ID_FOR_ACTION,
        payload:id
    }
}

export function dailyMenuIdForAction(id){
    return{
        type:DAILY_MENU_ID_FOR_ACTION,
        payload:id
    }
}
export function selectedDateUpdate(data) {
    return {
        type: DATE_UPDATE_FOR_STATE_MAINTENANCE,
        payload: data
    }
}

export function selectedStatusFilter(status){
    return{
        type: SELLER_SCHEDULE_MENU_STATUS_SELECTED,
        payload:status
    }
}


export function selectedSearchTextUpdate(text) {
    return {
        type: SEARCH_TEXT_STATE_UPDATE,
        payload: text
    }
}

export function selectedSizePerPageUpdate(text) {
    return {
        type: ROWS_PER_PAGE_STATE_UPDATE,
        payload: text
    }
}

export function selectedPaginationUpdate(text) {
    return {
        type: PAGINATION_UPDATE,
        payload: text
    }
}

export function pushDailyMenuUpdate(value){
    return{
        type: PUSH_DAILY_MENU_VALUE,
        payload: value
    }
}




// WEBPACK FOOTER //
// ./src/modules/DailyMenus/redux/dailymenus.js